import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"

interface NoteDetailModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  content?: string
  onEdit: () => void
}

export function NoteDetailModal({
  open,
  onOpenChange,
  title,
  content = "",
  onEdit,
}: NoteDetailModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[619px] p-[25px] gap-[20px]">
        <DialogHeader>
          <DialogTitle className="text-[18px] font-semibold text-[#3f4652]">{title}</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-[15px]">
          <div className="min-h-[283px] p-[12px] bg-white">
            <p className="text-[14px] text-[#3f4652] whitespace-pre-wrap">
              {content || "注意事項はありません"}
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-[20px]">
          <Button
            onClick={onEdit}
            className="bg-[#354267] hover:bg-[#354267]/90 text-white text-[14px] font-bold h-[32px] px-[16px]"
          >
            編集する
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
